import { Box, Container, Stack, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { useTheme } from '@emotion/react';

import DVRIcon from '../../../assets/icons/icon-dvr.svg';
import NoDocumentIcon from '../../../assets/icons/icon-no-document.svg';
import SavingIcon from '../../../assets/icons/icon-saving.svg';

const Feature = ({ icon, title, description, theme }) => {
  return (
    <Stack
      gap={2}
      sx={{
        justifyContent: 'flex-start',
        p: 3,
        border: '1px solid',
        borderColor: 'primary.neutral100',
        borderRadius: theme.shape.roundedButtonBorderRadius,
        boxShadow: `0 0 0 0.5px ${theme.palette.primary.neutral100}`,
        width: { xs: '100%', sm: 'calc(100% / 2)', md: 'calc(100% / 3)' },
      }}
    >
      <Box sx={{ pb: 1, minHeight: '45px' }}>{icon}</Box>
      <Typography variant="h3" sx={{ fontSize: '28px', fontWeight: '600' }}>
        {title}
      </Typography>
      <Typography
        variant="body1"
        sx={{ color: 'text.secondary', fontSize: '16px' }}
      >
        {description}
      </Typography>
    </Stack>
  );
};

export default function WhySlex() {
  const { t } = useTranslation();
  const theme = useTheme();

  const features = [
    {
      icon: (
        <img src={SavingIcon} alt="Saving Icon" loading="lazy" width={'48px'} />
      ),
      title: (
        <Trans
          i18nKey="LANDING_PAGES.EURO_QUALIFIERS.WHY_SLEX.FEATURES.0.TITLE"
          components={{ br: <br /> }}
        />
      ),
      description: t(
        'LANDING_PAGES.EURO_QUALIFIERS.WHY_SLEX.FEATURES.0.DESCRIPTION'
      ),
    },
    {
      icon: (
        <img
          src={NoDocumentIcon}
          alt="No Document icon"
          loading="lazy"
          width={'48px'}
        />
      ),
      title: t('LANDING_PAGES.EURO_QUALIFIERS.WHY_SLEX.FEATURES.1.TITLE'),
      description: t(
        'LANDING_PAGES.EURO_QUALIFIERS.WHY_SLEX.FEATURES.1.DESCRIPTION'
      ),
    },
    {
      icon: <img src={DVRIcon} alt="DVR icon" loading="lazy" width={'48px'} />,
      title: t('LANDING_PAGES.EURO_QUALIFIERS.WHY_SLEX.FEATURES.2.TITLE'),
      description: t(
        'LANDING_PAGES.EURO_QUALIFIERS.WHY_SLEX.FEATURES.2.DESCRIPTION'
      ),
    },
  ];
  return (
    <Container
      component="section"
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column' },
        justifyContent: 'center',
        alignItems: 'center',
        py: { xs: 8, md: 10 },
      }}
      maxWidth="lg"
    >
      <Stack gap={2}>
        <Stack component={'header'} gap={2}>
          <Typography
            variant="h2"
            sx={{ fontSize: '32px', fontWeight: '600', textAlign: 'center' }}
          >
            {t('LANDING_PAGES.EURO_QUALIFIERS.WHY_SLEX.TITLE')}
          </Typography>
        </Stack>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          gap={2}
          sx={{
            mt: '32px',
          }}
        >
          {features.map((feature, i) => (
            <Feature
              key={i}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
              theme={theme}
            />
          ))}
        </Stack>
      </Stack>
    </Container>
  );
}
